// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1nmQ4","rightAdornment":"Header_rightAdornment__1SMu1"};